// extracted by mini-css-extract-plugin
export default {"ring_sm":"LoadingSpinner_ring_sm__yQ+nc","ring":"LoadingSpinner_ring__oTcxy","ring_md":"LoadingSpinner_ring_md__Hil1D","ring_lg":"LoadingSpinner_ring_lg__dRrfd"};